<template lang="html">
  <div class="profile-my-sales-wrapper">
    <div v-if="windowWidth > 1000">
      <div class="actions-wrapper">
        <div class="btn-dropdown-wrapper">
          <div @click="navigateToNewAd()" class="btn dark-blue">
            <img src="@/assets/icons/plusWhite.png" alt="trash icon" />
            {{ $t("profile.purchase.newSale") }}
          </div>
        </div>
        <div class="search-wrapper">
          <InputView
            @input="(page = 1), getMySales()"
            v-model="search"
            type="text"
            :label="$t('nav.search')"
            icon="mdi:search"
          />
        </div>
      </div>
      <table v-if="purchases.length > 0">
        <thead>
          <tr>
            <td style="cursor: pointer;" @click="handleSort('pro_name')">
              {{ $t("profile.purchase.productService") }}
              <img
                v-if="sort === 'pro_name'"
                :class="{ asc: sortDirection !== 'asc' }"
                src="@/assets/icons/dropdownArrow.png"
                alt="arrow"
              />
            </td>
            <td style="cursor: pointer;" @click="handleSort('off_quantity')">
              {{ $t("profile.purchase.totalQuantity") }}
              <img
                v-if="sort === 'off_quantity'"
                :class="{ asc: sortDirection !== 'asc' }"
                src="@/assets/icons/dropdownArrow.png"
                alt="arrow"
              />
            </td>
            <td>{{ $t("profile.purchase.price") }}</td>
            <td style="cursor: pointer;" @click="handleSort('pro_post_date')">
              {{ $t("profile.purchase.date") }}
              <img
                v-if="sort === 'pro_post_date'"
                :class="{ asc: sortDirection !== 'asc' }"
                src="@/assets/icons/dropdownArrow.png"
                alt="arrow"
              />
            </td>
            <td style="width: 40px"></td>
            <td style="width: 40px"></td>
            <td style="width: 40px"></td>
            <td style="width: 40px"></td>
            <td style="width: 40px"></td>
          </tr>
        </thead>
        <tbody>
          <template v-for="purchase in purchases">
            <tr
              :class="{ deleted: purchase.archived === 1 }"
              :key="purchase.pro_id"
              @click="purchase.open = !purchase.open"
            >
              <td>
                <span
                  :title="$t('main.viewProduct')"
                  class="underline"
                  @click="navigateToAd(purchase.pro_id, $event)"
                >
                  {{ purchase.pro_name }}
                </span>
              </td>
              <td>
                {{ purchase.off_quantity }}
              </td>
              <td>
                {{
                  purchase.current_price
                    .toLocaleString("en")
                    .split(",")
                    .join(".")
                }}
                {{ purchase.cur_id }}
              </td>
              <td>
                {{ purchase.pro_post_date.substring(0, 10) }}
              </td>
              <td>
                <div class="icon-wrapper">
                  <span
                    style="white-space: nowrap; text-decoration: none !important"
                    >{{ $t("main.buyersList") }}</span
                  >
                  <img
                    :title="$t('main.details')"
                    style="height: 10px; margin-left: 5px;"
                    src="@/assets/icons/dropdownArrowBig.png"
                    alt="eye icon"
                  />
                </div>
              </td>
              <td
                v-if="purchase.editable === 1 && purchase.archived !== 1"
                @click="edit(purchase, $event)"
              >
                <div class="icon-wrapper">
                  <img
                    :title="$t('main.edit')"
                    src="@/assets/icons/pen.png"
                    alt="pen icon"
                  />
                </div>
              </td>
              <td v-else></td>
              <td
                v-if="purchase.deletable === 1 && purchase.archived !== 1"
                @click="openDeleteConfirmation(purchase, $event)"
              >
                <div class="icon-wrapper">
                  <img
                    :title="$t('main.delete')"
                    src="@/assets/icons/trash.png"
                    alt="trash icon"
                  />
                </div>
              </td>
              <td v-else></td>
              <td v-if="purchase.renewable" @click="renew(purchase, $event)">
                <div class="icon-wrapper">
                  <img
                    :title="$t('main.renew')"
                    src="@/assets/icons/repeat.png"
                    alt="close icon"
                  />
                </div>
              </td>
              <td v-else></td>
              <td v-if="purchase.can_hide" @click="archive(purchase, $event)">
                <div class="icon-wrapper">
                  <img
                    :title="$t('main.deleteFromArchive')"
                    src="@/assets/icons/closeRed.png"
                    alt="close icon"
                  />
                </div>
              </td>
              <td v-else></td>
            </tr>
            <tr
              class="dropdown-row"
              :key="purchase.pro_id + 'd'"
              :class="{ active: purchase.open }"
            >
              <td colspan="100%" class="dropdown-td">
                <div class="dropdown">
                  <my-sales-buyers
                    :rejectable="purchase.pro_reject === 1"
                    v-if="purchase.open"
                    :modalData="purchase"
                  />
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div class="empty" v-else>
        {{ $t("main.noSales") }}
      </div>
      <div v-if="purchases.length > 0" class="pagination-wrapper">
        <paginate
          v-model="page"
          :page-count="pageCount"
          :prev-text="getPaginationImages('Left')"
          :next-text="getPaginationImages('Right')"
          :container-class="'pagination'"
          :page-class="'page'"
          :click-handler="changePage"
        >
        </paginate>
      </div>
    </div>
    <div v-if="windowWidth <= 1000">
      <my-sales-mobile
        :_sortSelected="sortSelected"
        :_search="search"
        :_page="page"
        @changeSort="handleMobileSort($event)"
        @changeSearch="(search = $event), getMySales()"
        @changePage="(page = $event), getMySales()"
      />
    </div>
  </div>
</template>

<script>
import mySalesBuyers from "@/components/profile/mySalesBuyers.vue";
import eventBus from "@/shared/eventBus.js";
import { api } from "@/api";
import mySalesMobile from "../profileMobile/mySalesMobile";
import TestInput from "../shared/testInput.vue";
export default {
  name: "profileMySales",
  components: {
    mySalesBuyers,
    mySalesMobile,
    InputView: TestInput
  },
  data() {
    return {
      purchases: [],
      page: 1,
      pageCount: 0,
      search: null,
      windowWidth: window.innerWidth,
      sort: "pro_post_date",
      sortDirection: "desc",
      sortSelected: null
    };
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  activated() {
    // this.getMySales()
    this.purchases = [];
    this.getMySales();
    this.page = 1;
    this.setSortSelected();
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    handleSort(str) {
      if (this.sort === str) {
        this.sortDirection = this.sortDirection === "desc" ? "asc" : "desc";
      } else {
        this.sort = str;
        this.sortDirection = "desc";
      }
      this.setSortSelected();
    },
    handleMobileSort(evt) {
      if (!evt) {
        this.sort = null;
        this.sortDirection = "desc";
        this.setSortSelected();
        return;
      }
      switch (evt.value) {
        case 1:
          this.sort = "off_quantity";
          this.sortDirection = "desc";
          break;
        case 2:
          this.sort = "off_quantity";
          this.sortDirection = "asc";
          break;
        case 3:
          this.sort = "pro_post_date";
          this.sortDirection = "desc";
          break;
        case 4:
          this.sort = "pro_post_date";
          this.sortDirection = "asc";
          break;
        case 5:
          this.sort = "pro_name";
          this.sortDirection = "desc";
          break;
        case 6:
          this.sort = "pro_name";
          this.sortDirection = "asc";
          break;
        default:
          this.sort = null;
          this.sortDirection = "desc";
      }
      this.setSortSelected();
    },
    setSortSelected() {
      let obj = {};
      if (this.sort === "pro_name") {
        if (this.sortDirection === "desc") {
          obj.label = this.$t("profile.sales.sort.5");
          obj.value = 5;
        } else {
          obj.label = this.$t("profile.sales.sort.6");
          obj.value = 6;
        }
      }
      if (this.sort === "off_quantity") {
        if (this.sortDirection === "desc") {
          obj.label = this.$t("profile.sales.sort.1");
          obj.value = 1;
        } else {
          obj.label = this.$t("profile.sales.sort.2");
          obj.value = 2;
        }
      }
      if (this.sort === "pro_post_date") {
        if (this.sortDirection === "desc") {
          obj.label = this.$t("profile.sales.sort.3");
          obj.value = 3;
        } else {
          obj.label = this.$t("profile.sales.sort.4");
          obj.value = 4;
        }
      }
      this.sortSelected = obj;
      this.getMySales();
    },
    getMySales() {
      let params = {
        page: this.page
      };
      if (this.sort) {
        params.sort = this.sort;
        params.sort_direction = this.sortDirection;
      }
      if (this.search && this.search !== "") {
        params.search = this.search;
      }
      api
        .getMySales(params)
        .then(res => {
          for (var i = 0; i < res.data.data.length; i++) {
            res.data.data[i].open = false;
          }
          this.purchases = res.data.data;
          this.pageCount = res.data.page_count;
        })
        .catch(e => {
          console.log(e);
        });
    },
    edit(product, e) {
      e.stopPropagation();
      console.log("redirect", product.pro_id);
      let params = Object.assign({}, this.$route.params);
      params.id = product.pro_id;
      this.$router.push({ name: "EditAd", params: params });
    },
    renew(data, e) {
      e.stopPropagation();
      let modalData = {
        title: this.$t("main.renew"),
        id: data.pro_id,
        cancel: () => {
          this.getMySales();
        }
      };
      let params = {
        modalData: modalData,
        component: "renewModal"
      };
      eventBus.$emit("openModal", params);
    },
    archive(data, e) {
      e.stopPropagation();
      let modalData = {
        title: this.$t("modal.archiveProduct"),
        ok: () => {
          this.archiveProduct(data);
        }
      };
      let params = {
        modalData: modalData,
        component: "confirmModal"
      };
      eventBus.$emit("openModal", params);
    },
    archiveProduct(data) {
      let params = {
        pro_id: data.pro_id
      };
      api
        .deleteProductFromArchive(params)
        .then(res => {
          this.getMySales();
        })
        .catch(e => {
          console.log(e);
        });
    },
    openDeleteConfirmation(product, e) {
      e.stopPropagation();
      let modalData = {
        title: this.$t("modal.deleteProductTitle") + product.pro_name,
        ok: () => {
          this.deleteProduct(product);
        }
      };
      let params = {
        modalData: modalData,
        component: "confirmModal"
      };
      eventBus.$emit("openModal", params);
    },
    deleteProduct(product) {
      let params = {
        id: product.pro_id
      };
      eventBus.$emit("showLoader", true);
      api
        .deleteProduct(params)
        .then(res => {
          this.$toast.success(this.$t("main.deleteProductSuccess"), {
            duration: 8000
          });
          this.getMySales();
        })
        .catch(e => {
          console.log(e);
          this.$toast.error(this.$t("main.deleteProductError"), {
            duration: 8000
          });
        })
        .finally(() => {
          eventBus.$emit("showLoader", false);
        });
    },
    openOffersList(purchase) {
      let params = {
        modalData: purchase,
        component: "productBuyers"
      };
      eventBus.$emit("openModal", params);
    },
    navigateToNewAd() {
      this.$router.push({ name: "NewAd", params: { lang: this.$i18n.locale } });
    },
    navigateToAd(id, e) {
      e.stopPropagation();
      this.$router.push({
        name: "Details",
        params: { lang: this.$i18n.locale, id: id }
      });
    },
    getPaginationImages(side) {
      let path = require(`@/assets/icons/pagination${side}.png`);
      return `<img src='${path}' alt='pagination left image'>`;
    },
    changePage(page) {
      this.page = page;
      this.purchases = [];
      this.getMySales();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
@import "@/assets/scss/tableStyles.scss";
.profile-my-sales-wrapper {
  padding-left: 40px;

  .empty {
    text-align: left;
  }
  .dropdown-row {
    td {
      // border-bottom: 1px solid #e8e8e8;
      height: 0px;
      padding: 0px;
      overflow: hidden;
      transition-duration: 0.3s;

      .dropdown {
        height: 0px;
        transition-duration: 0.3s;
      }
    }
  }
  .dropdown-row.active {
    cursor: default;
    td {
      // border-bottom: none;
      height: auto;
      padding: 20px 5px;
      overflow: hidden;
      transition-duration: 0.3s;

      .dropdown {
        height: auto;
        transition-duration: 0.3s;
        // border: 1px solid rgba(243, 243, 243, 0.7);
        box-sizing: border-box;
        // box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
        // padding: 20px;

        .info {
          margin-bottom: 10px;
          display: flex;
          flex-direction: row;
          align-items: flex-start;

          .info-key {
            font-weight: normal;
            font-size: 13px;
            line-height: 21px;
            color: #787878;
            margin-right: 10px;
            white-space: nowrap;
          }
          .info-value {
            font-weight: 800;
            font-size: 13px;
            line-height: 21px;
            letter-spacing: 0.02em;
            color: $text-color;
          }
        }
        .dropdown-header {
          display: flex;
          justify-content: space-between;

          .header {
            font-weight: bold;
            font-size: 17px;
            line-height: 28px;
            letter-spacing: 0.06em;
            text-transform: uppercase;
          }
          div {
            margin-bottom: 15px;
          }
        }
        .info-wrapper {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          position: relative;
          margin-bottom: 15px;

          .left {
            width: calc(50% - 20px);
          }
          .right {
            width: calc(50% - 20px);
          }
          textarea {
            flex-grow: 1;
            resize: none;
          }
        }
      }
    }
  }
  tr.deleted td {
    background: rgba(196, 196, 196, 0.15);
  }

  thead td img {
    padding-bottom: 3px;
  }
  thead td img.asc {
    transform: rotate(180deg);
    padding-bottom: 0px;
    padding-top: 3px;
  }
  // tbody tr td {
  //   border-bottom: none;
  // }
  tbody tr td span {
    text-decoration: underline !important;
  }
  tbody tr {
    cursor: pointer;
  }
  thead {
    text-transform: uppercase;
  }
  .actions-wrapper {
    margin-bottom: 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .btn-dropdown-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;

      .btn {
        margin-right: 5px;
      }
    }
    .btn {
      width: 170px;
    }
  }
  @media only screen and (max-width: 768px) {
    .actions-wrapper {
      flex-direction: column;
      .btn {
        margin-bottom: 40px;
      }
    }
  }
}
</style>
